export default "__VITE_ASSET__DIMsN9TN__"